(function () {
  var activeController = null;
  var loadingRadio = null;
  var htmlCache = {};

  function showLoader(radioEl) {
    hideLoader();
    if (radioEl) {
      loadingRadio = radioEl;
      radioEl.classList.add('mpb-radio-loading');
    }
  }

  function hideLoader() {
    if (loadingRadio) {
      loadingRadio.classList.remove('mpb-radio-loading');
      loadingRadio = null;
    }
  }

  function ajaxSwapProduct(productUrl, sectionId, radioEl) {
    if (activeController) activeController.abort();
    activeController = new AbortController();

    var currentSection = document.getElementById('shopify-section-' + sectionId);
    if (!currentSection) {
      window.location.href = productUrl;
      return;
    }

    var stickyAtcEl = document.querySelector('sticky-atc-bar[data-section]');
    var stickyAtcSectionId = stickyAtcEl ? stickyAtcEl.getAttribute('data-section') : '';

    showLoader(radioEl);

    // Remember where the radio sits in the viewport so we can pin it after swap
    var radioViewportTop = radioEl ? radioEl.getBoundingClientRect().top : 0;

    var baseUrl = productUrl.split('?')[0];
    var fetchOptions = { signal: activeController.signal };

    var mainUrl = baseUrl + '?section_id=' + sectionId;
    var mainFetch = htmlCache[mainUrl]
      ? Promise.resolve(htmlCache[mainUrl])
      : fetch(mainUrl, fetchOptions).then(function (r) { return r.text(); }).then(function (html) { htmlCache[mainUrl] = html; return html; });

    var stickyUrl = stickyAtcSectionId ? baseUrl + '?section_id=' + stickyAtcSectionId : '';
    var stickyFetch = stickyAtcSectionId
      ? (htmlCache[stickyUrl]
          ? Promise.resolve(htmlCache[stickyUrl])
          : fetch(stickyUrl, fetchOptions).then(function (r) { return r.text(); }).then(function (html) { htmlCache[stickyUrl] = html; return html; }))
      : Promise.resolve('');

    Promise.all([mainFetch, stickyFetch])
      .then(function (responses) {
        var mainHtml = new DOMParser().parseFromString(responses[0], 'text/html');
        var newSection = mainHtml.querySelector('.shopify-section');
        var stickyHtmlText = responses[1];

        if (!newSection) {
          window.location.href = productUrl;
          return;
        }

        // Strip only external scripts (already loaded, re-execution causes errors)
        // Keep inline scripts (component init like reviews dropdown, toggleDropdown etc.)
        // Fix non-blocking CSS: onload handlers don't fire via innerHTML,
        // so set media="all" directly since files are already cached
        function preprocessSection(node) {
          node.querySelectorAll('script[src]:not([type="application/json"]):not([type="application/ld+json"])').forEach(function (s) { s.remove(); });
          node.querySelectorAll('link[rel="stylesheet"][media="print"]').forEach(function (link) {
            link.removeAttribute('onload');
            link.setAttribute('media', 'all');
          });
        }

        // Save scroll position before viewTransition to counteract
        // any scroll triggered by connectedCallback during DOM insertion
        // (e.g. media-gallery.sortMediaItems calling window.scrollTo)
        var savedScrollY = window.scrollY;

        try {
        // Swap main product section
        HTMLUpdateUtility.viewTransition(
          currentSection,
          newSection,
          [preprocessSection],
          [function (newNode) {
            // Re-initialize Shopify Payment Buttons
            if (window.Shopify && Shopify.PaymentButton) {
              try { Shopify.PaymentButton.init(); } catch (e) { /* non-fatal */ }
            }
            // Re-initialize main product block bindings
            if (window.__initMainProductBlock) {
              window.__initMainProductBlock();
            }
            // Re-initialize reviews block (scoped to newNode to avoid old/new overlap)
            if (window.__initReviewsBlock) {
              window.__initReviewsBlock(newNode);
            }
            // Re-initialize bd-product-set Swiper slider
            if (typeof Swiper !== 'undefined') {
              newNode.querySelectorAll('[js-bd-product-set]').forEach(function (el) {
                new Swiper(el, { slidesPerView: 'auto', spaceBetween: 20 });
              });
            }
            // Re-initialize upsell close buttons
            newNode.querySelectorAll('[js-upsell-product-close-btn]').forEach(function (closeBtn) {
              closeBtn.addEventListener('click', function () {
                var widget = closeBtn.closest('[js-product-upsell-widget]');
                if (widget) widget.classList.remove('active');
                var cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer && cartDrawer.show) cartDrawer.show();
              });
            });
            // Re-initialize bd-set-contents modals/accordions
            if (window.__initBdSetContents) {
              window.__initBdSetContents();
            }
            // Re-create IntersectionObserver for viewport-section class
            var newProductInfo = newNode.querySelector('product-info');
            if (newProductInfo) {
              var viewportObserver = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                  if (entry.isIntersecting) {
                    newProductInfo.classList.add('viewport-section');
                  } else {
                    newProductInfo.classList.remove('viewport-section');
                  }
                });
              }, { threshold: 0.2 });
              viewportObserver.observe(newProductInfo);
            }
            // Reset gallery to first slide after Swiper initializes
            var gallery = newNode.querySelector('media-gallery');
            if (gallery) {
              var resetGallery = function () {
                if (gallery.sliderInstance && gallery.sliderInstance.slider) {
                  var scrollBefore = window.scrollY;
                  gallery.sliderInstance.slider.slideToLoop(0, 0);
                  // Restore scroll after Swiper autoHeight changes the
                  // container height (prevents scroll-anchoring shift).
                  window.scrollTo({ top: scrollBefore, behavior: 'instant' });
                } else {
                  setTimeout(resetGallery, 50);
                }
              };
              setTimeout(resetGallery, 50);
            }
            // Dispatch shopify:section:load so components like product-upsell re-initialize
            document.dispatchEvent(new CustomEvent('shopify:section:load', {
              detail: { sectionId: sectionId },
              bubbles: true
            }));

            // Pin the clicked radio AFTER all re-initializations so layout
            // changes from Payment Buttons, Swiper, etc. are already settled.
            window.scrollTo({ top: savedScrollY, behavior: 'instant' });
            var newRadio = newNode.querySelector('[data-mpb-radio]:checked');
            if (newRadio) {
              var newTop = newRadio.getBoundingClientRect().top;
              var delta = newTop - radioViewportTop;
              if (delta !== 0) {
                window.scrollTo({ top: savedScrollY + delta, behavior: 'instant' });
              }
            }

            hideLoader();
          }]
        );

        // Swap sticky ATC bar section
        if (stickyAtcSectionId && stickyHtmlText) {
          var stickyHtml = new DOMParser().parseFromString(stickyHtmlText, 'text/html');
          var newStickySection = stickyHtml.querySelector('.shopify-section');
          var currentStickyAtc = document.getElementById('shopify-section-' + stickyAtcSectionId);
          if (currentStickyAtc && newStickySection) {
            HTMLUpdateUtility.viewTransition(currentStickyAtc, newStickySection, [preprocessSection], []);
          }
        }

        // Update browser URL
        window.history.replaceState({}, '', baseUrl);
        } catch (swapError) {
          console.error('MPB: DOM swap error (non-fatal)', swapError);
          hideLoader();
        }
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        console.error('MPB: AJAX swap failed, falling back to navigation', error);
        window.location.href = productUrl;
      })
      .finally(function () {
        activeController = null;
      });
  }

  function initMainProductBlock() {
    var containers = document.querySelectorAll('[data-mpb-section]');
    containers.forEach(function (container) {
      if (container.hasAttribute('data-mpb-initialized')) return;
      container.setAttribute('data-mpb-initialized', '');

      var cards = container.querySelectorAll('[data-mpb-card]');

      // Make the entire card clickable for collapse/expand + selection
      cards.forEach(function (card) {
        card.addEventListener('click', function (e) {
          // Don't interfere with toggle area clicks
          if (e.target.closest('.main-product-block__toggle')) return;

          var radio = card.querySelector('[data-mpb-radio]');
          if (!radio) return;

          var wasSelected = card.classList.contains('is-selected');

          // Toggle is-selected: expand clicked card, collapse others
          container.querySelectorAll('[data-mpb-card]').forEach(function (c) {
            c.classList.remove('is-selected');
          });
          card.classList.add('is-selected');
          radio.checked = true;

          // Fire AJAX only if this card was not already selected
          if (!wasSelected && card.getAttribute('data-is-current') !== 'true') {
            var url = card.getAttribute('data-product-url');
            if (!url) return;
            ajaxSwapProduct(url, container.getAttribute('data-mpb-section'), radio);
          }
        });
      });

      var switches = container.querySelectorAll('[data-mpb-toggle]');
      switches.forEach(function (switchEl) {
        switchEl.addEventListener('click', function () {
          var currentCard = switchEl.closest('[data-mpb-card]');
          if (!currentCard) return;
          var currentRole = currentCard.getAttribute('data-mpb-slot-role');
          if (!currentRole) return;
          var targetRole = currentRole === 'default' ? 'alternate' : 'default';
          var targetCard = container.querySelector('[data-mpb-card][data-mpb-slot-role="' + targetRole + '"]');
          if (!targetCard) return;

          var wasSelected = currentCard.classList.contains('is-selected');

          if (wasSelected) {
            // Full AJAX swap — pass current visible radio for correct scroll pinning
            var targetUrl = targetCard.getAttribute('data-product-url');
            var currentRadio = currentCard.querySelector('[data-mpb-radio]');
            if (targetUrl) {
              ajaxSwapProduct(targetUrl, container.getAttribute('data-mpb-section'), currentRadio);
            }
          } else {
            // Just swap card visibility (product 1 is active, no AJAX needed)
            currentCard.style.display = 'none';
            targetCard.style.display = '';
          }
        });
      });
    });

    // Tooltip overflow detection
    var tooltipTriggers = document.querySelectorAll('.be-product-set__content');
    tooltipTriggers.forEach(function (trigger) {
      if (trigger.hasAttribute('data-mpb-tooltip-initialized')) return;
      trigger.setAttribute('data-mpb-tooltip-initialized', '');

      trigger.addEventListener('mouseenter', function () {
        var tooltip = trigger.querySelector('.be-product-set__content--text');
        if (!tooltip) return;
        tooltip.style.transition = 'none';
        tooltip.classList.remove('flip-right');
        void tooltip.offsetWidth;
        var rect = tooltip.getBoundingClientRect();
        var container = trigger.closest('.product__blocks');
        var boundary = container ? container.getBoundingClientRect().right : window.innerWidth;
        if (rect.right > boundary) {
          tooltip.classList.add('flip-right');
        }
        void tooltip.offsetWidth;
        requestAnimationFrame(function () {
          tooltip.style.transition = '';
        });
      });
    });
  }

  window.__initMainProductBlock = initMainProductBlock;
  initMainProductBlock();
})();
